//react
import { useState } from "react";

//utils
import { formatter } from "../../Utils";

//components
import { GearButton } from "../GearButton";
import {
  ButtonsContainer,
  Container,
  InfosContainer,
  Price,
  Title,
} from "./styles";
import ModalElement from "../Modal";
import { RegisterServiceForm } from "../FormRegisterServices";

//providers
import { useServices } from "../../Providers/Services";
import { useProducts } from "../../Providers/Products";
import { CloseButton } from "../CloseButton";
import { RegisterProductsForm } from "../FormRegisterProducts";
import { IProductAPI, IServiceAPI } from "../../Interfaces";
import { useUser } from "../../Providers/User";

interface CardProductOrServiceProps {
  infs: IProductAPI | IServiceAPI;
  type: "product" | "service";
  setProds?: (newState: IProductAPI[]) => void;
  prods?: IProductAPI[];
  setServices?: (newState: IServiceAPI[]) => void;
  services?: IServiceAPI[];
}

const CardProductOrService = ({
  infs,
  type,
  setProds,
  prods,
  setServices,
  services,
}: CardProductOrServiceProps) => {
  const { title, price, id } = infs;
  const [showModal, setShowModal] = useState<boolean>(false);
  const { admAuth } = useUser();

  const { editService, deleteService, getServices } = useServices();
  const { editProduct, deleteProduct, getProducts } = useProducts();

  const handleModal = () => {
    setShowModal(!showModal);
  };

  const deleteCard = () => {
    if (type === "product") {
      if (prods !== undefined && setProds !== undefined) {
        const selected = prods?.findIndex((el) => el.id === id);
        const newState = prods;
        newState?.splice(selected, 1);
        setProds(newState);
      }
      deleteProduct(id);
      getProducts();
    } else {
      if (services !== undefined && setServices !== undefined) {
        const selected = services?.findIndex((el) => el.id === id);
        const newState = services;
        newState?.splice(selected, 1);
        setServices(newState);
      }
      deleteService(id);
      getServices();
    }
  };

  return (
    <Container>
      <InfosContainer>
        <Title>{infs.title}</Title>
        <Price>{formatter.format(infs.price)}</Price>
      </InfosContainer>
      <ButtonsContainer>
        {admAuth && <GearButton showModal={handleModal} />}
        {admAuth && <CloseButton deleteFunctionForId={deleteCard} id={id} />}
      </ButtonsContainer>
      <ModalElement closeModal={handleModal} isOpen={showModal}>
        {type === "product" ? (
          <RegisterProductsForm
            product={{ currentPrice: price, currentTitle: title, id: id }}
            handleForm={editProduct}
            buttonName="Editar"
            handleModal={handleModal}
          />
        ) : (
          <RegisterServiceForm
            service={{ currentTitle: title, currentPrice: price, id: id }}
            handleForm={editService}
            buttonName="Editar"
            handleModal={handleModal}
          />
        )}
      </ModalElement>
    </Container>
  );
};

export default CardProductOrService;
